export default [
  {
    path: '/404',
    name: '404',
    component: () => import('../views/pages/generic/404.vue')
  },
  {
    path: '/',
    name: 'login',
    component: () => import('../views/pages/auth/loginToken.vue')
  },
  {
    path: '/login',
    name: 'loginAuth',
    component: () => import('../views/pages/auth/loginAuth.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/pages/starter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/pages/starter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/affiliate/detail',
    name: 'reportAffiliateDetail',
    component: () => import('../views/pages/reports/affiliate/detailReport.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/registers/user/list',
    name: 'userList',
    component: () => import('@/views/pages/registers/user/userList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/user/create',
    name: 'userCreate',
    component: () => import('@/views/pages/registers/user/userForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/user/:id',
    name: 'userUpdate',
    component: () => import('@/views/pages/registers/user/userForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/affiliate/list',
    name: 'affiliateList',
    component: () => import('@/views/pages/registers/affiliate/affiliateList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/affiliate/create',
    name: 'affiliateCreate',
    component: () => import('@/views/pages/registers/affiliate/affiliateForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/affiliate/:id',
    name: 'affiliateUpdate',
    component: () => import('@/views/pages/registers/affiliate/affiliateForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/action/list',
    name: 'actionList',
    component: () => import('@/views/pages/registers/action/actionList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/action/create',
    name: 'actionCreate',
    component: () => import('@/views/pages/registers/action/actionForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/action/:id',
    name: 'actionUpdate',
    component: () => import('@/views/pages/registers/action/actionForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/campaign/list',
    name: 'campaignList',
    component: () => import('@/views/pages/registers/campaign/campaignList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/campaign/create',
    name: 'campaignCreate',
    component: () => import('@/views/pages/registers/campaign/campaignForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/campaign/:id',
    name: 'campaignUpdate',
    component: () => import('@/views/pages/registers/campaign/campaignForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/affiliate/activity',
    name: 'reportAffiliateActivity',
    component: () => import('@/views/pages/reports/affiliate/activity/activityReport.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/general/v2/',
    name: 'entryByLevelV2',
    component: () => import('@/views/pages/reports/general/generalReportV2.vue'),
    params: true,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/general/v2/:partnerToken',
    name: 'entryByLevelAndPartner',
    component: () => import('@/views/pages/reports/general/generalReportV2.vue'),
    params: true,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/general',
    name: 'entryByLevel',
    component: () => import('@/views/pages/reports/general/generalReport.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/financial/affiliate/payment',
    name: 'affiliatePaymentReport',
    component: () => import('@/views/pages/financial/AffiliatePayments.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/financial/entries',
    name: 'AffiliateEntries',
    component: () => import('@/views/pages/financial/affiliateEntries/AffiliateEntries.vue'),
    params: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/reward/list',
    name: 'rewardList',
    component: () => import('@/views/pages/registers/reward/rewardList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/reward/create',
    name: 'rewardCreate',
    component: () => import('@/views/pages/registers/reward/rewardForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/reward/:id',
    name: 'rewardUpdate',
    component: () => import('@/views/pages/registers/reward/rewardForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/reward/profile/list',
    name: 'rewardProfileList',
    component: () => import('@/views/pages/registers/rewardProfile/rewardProfileList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/reward/profile/create',
    name: 'rewardProfileCreate',
    component: () => import('@/views/pages/registers/rewardProfile/rewardProfileForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/reward/profile/:id',
    name: 'rewardProfileUpdate',
    component: () => import('@/views/pages/registers/rewardProfile/rewardProfileForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/company/list',
    name: 'companyList',
    component: () => import('@/views/pages/registers/company/companyList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/company/:id',
    name: 'companyUpdate',
    component: () => import('@/views/pages/registers/company/companyForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/brand/list',
    name: 'brandList',
    component: () => import('@/views/pages/registers/brand/brandList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/brand/:id',
    name: 'brandUpdate',
    component: () => import('@/views/pages/registers/brand/brandForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/partner/list',
    name: 'partnerList',
    component: () => import('@/views/pages/registers/partner/partnerList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login/partner',
    name: 'loginPartnerToken',
    component: () => import('@/views/pages/auth/loginPartnerToken.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/registers/partner/:id',
    name: 'partnerUpdate',
    component: () => import('@/views/pages/registers/partner/partnerForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/partner/create',
    name: 'partnerCreate',
    component: () => import('@/views/pages/registers/partner/partnerForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/partnerLevel/list',
    name: 'partnerLevelList',
    component: () => import('@/views/pages/registers/partnerLevel/partnerLevelList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/partnerLevel/:id',
    name: 'partnerLevelUpdate',
    component: () => import('@/views/pages/registers/partnerLevel/partnerLevelForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/partnerLevel/create',
    name: 'partnerLevelCreate',
    component: () => import('@/views/pages/registers/partnerLevel/partnerLevelForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/partners',
    name: 'partnerLevelReport',
    component: () => import('@/views/pages/reports/partners/partnerLevelReport.vue')
  },
  {
    path: '/reports/lottery',
    name: 'lotteryReport',
    component: () => import('@/views/pages/reports/lottery/lotteryReport.vue')
  },
  {
    path: '/reports/cpa',
    name: 'cpaReport',
    component: () => import('@/views/pages/reports/cpa/cpaReport.vue')
  },
  {
    path: '/registers/subBrand/create',
    name: 'subBrandCreate',
    component: () => import('@/views/pages/registers/subBrand/subBrandForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/subBrand/list',
    name: 'subBrandList',
    component: () => import('@/views/pages/registers/subBrand/subBrandList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/subBrand/:id',
    name: 'subBrandUpdate',
    component: () => import('@/views/pages/registers/subBrand/subBrandForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/registers/subBrand/create',
    name: 'subBrandCreate',
    component: () => import('@/views/pages/registers/subBrand/subBrandForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/management/sys_activity_log',
    name: 'sysActivityLogList',
    component: () => import('@/views/pages/management/sysActivityLog/sysActivityLogList.vue'),
    meta: { requiresAuth: true }
  }
];
